export default {
  register: {
    title: 'สมัครสมาชิก',
    username: 'ชื่อผู้ใช้',
    phone: 'หมายเลขโทรศัพท์',
    phoneCode: 'รหัส',
    email: 'อีเมล',
    password: 'รหัสผ่าน',
    captcha: 'รหัสยืนยัน',
    smsCode: 'รหัส SMS',
    emailCode: 'รหัสอีเมล',
    verificationCode: 'รหัสอีเมล',
    invitationCode: 'รหัสเชิญ',
    loading: 'กำลังโหลด...',
    send: 'ส่ง',
    sendCode: 'ส่งรหัส',
    signUp: 'สมัครสมาชิก',
    contactUs: 'ติดต่อเรา？',
    haveAccount: 'มีบัญชีแล้ว?',
    signIn: 'เข้าสู่ระบบ',
    loginNow: 'เข้าสู่ระบบ',
    or: 'หรือ',
    orSignUpWith: 'หรือสมัครสมาชิกด้วย',
    methodUsername: 'ชื่อผู้ใช้',
    methodPhone: 'โทรศัพท์',
    methodEmail: 'อีเมล',
    codeOptional: 'รหัส (ไม่บังคับ)',
    privacyPolicy: 'ฉันยืนยันว่าอายุเกิน 18 ปีและยอมรับ',
    privacyPolicyLink: 'นโยบายความเป็นส่วนตัว',
    and: 'และ',
    termsConditions: 'ข้อกำหนดและเงื่อนไข',
    vault: 'ตู้นิรภัย',
    receivePromos: 'รับโปรโมชั่นทางอีเมล',
    usernameRequired: 'กรุณากรอกชื่อผู้ใช้',
    usernameInvalid: 'ชื่อผู้ใช้สามารถมีได้เฉพาะตัวอักษร ตัวเลข และขีดล่าง',
    phoneRequired: 'กรุณากรอกหมายเลขโทรศัพท์',
    phoneInvalid: 'รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง',
    emailRequired: 'กรุณากรอกอีเมล',
    emailInvalid: 'รูปแบบอีเมลไม่ถูกต้อง',
    passwordRequired: 'กรุณากรอกรหัสผ่าน',
    passwordInvalid: 'รหัสผ่านไม่ตรงตามข้อกำหนด',
    captchaRequired: 'กรุณากรอกรหัสยืนยัน',
    smsCodeRequired: 'กรุณากรอกรหัส SMS',
    emailCodeRequired: 'กรุณากรอกรหัสอีเมล',
    privacyPolicyRequired: 'กรุณายอมรับนโยบายความเป็นส่วนตัวและข้อกำหนดและเงื่อนไข',
    passwordHintLow: 'อย่างน้อย 6 หลัก',
    passwordHintMedium: 'อย่างน้อย 6 ตัวอักษรพร้อมตัวอักษรและตัวเลข',
    passwordHintHigh: 'อย่างน้อย 6 ตัวอักษรพร้อมตัวอักษร ตัวเลข และสัญลักษณ์',
    // Format validation
    usernameFormat: 'ใช้ได้เฉพาะตัวอักษร ตัวเลข และ _',
    emailFormat: 'รูปแบบอีเมลไม่ถูกต้อง',
    // Toast messages
    smsCodeSent: 'ส่งรหัส SMS แล้ว',
    emailCodeSent: 'ส่งรหัสอีเมลแล้ว',
    smsCodeFailed: 'ส่งรหัส SMS ไม่สำเร็จ',
    emailCodeFailed: 'ส่งรหัสอีเมลไม่สำเร็จ',
    registerSuccess: 'สมัครสมาชิกสำเร็จ',
    registerFailed: 'สมัครสมาชิกไม่สำเร็จ',
    // Google sign in
    signInWithGoogle: 'เข้าสู่ระบบด้วย Google+'
  }
};
